import React, { useState, useEffect } from 'react';
import { Button, OverlayTrigger, Popover } from 'react-bootstrap';
import { Plus } from 'react-bootstrap-icons';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

const QuickLabelAdd = ({ task, activeProfileId, onTaskUpdate }) => {
    const [availableLabels, setAvailableLabels] = useState([]);
    const [showPopover, setShowPopover] = useState(false);

    useEffect(() => {
        if (activeProfileId) {
            fetchLabels();
        }
    }, [activeProfileId]);

    const fetchLabels = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/life/profiles/${activeProfileId}/labels`);
            setAvailableLabels(response.data);
        } catch (error) {
            console.error('Error fetching labels:', error);
        }
    };

    const handleAddLabel = async (labelId) => {
        const currentLabelIds = task.labels ? task.labels.map(l => l.id) : [];
        if (currentLabelIds.includes(labelId)) return;
        
        const updatedLabels = [...currentLabelIds, labelId];
        
        try {
            const response = await axios.put(`${API_BASE_URL}/api/life/tasks/${task.id}`, {
                labels: updatedLabels
            });
            onTaskUpdate(response.data);
            setShowPopover(false);
        } catch (error) {
            console.error('Error adding label:', error);
        }
    };

    const unassignedLabels = availableLabels.filter(label => 
        !task.labels?.some(taskLabel => taskLabel.id === label.id)
    );

    if (unassignedLabels.length === 0) return null;

    const popover = (
        <Popover>
            <Popover.Body>
                <div className="d-flex flex-column gap-1">
                    {unassignedLabels.map(label => (
                        <Button
                            key={label.id}
                            variant="link"
                            size="sm"
                            className="p-1 text-start"
                            onClick={(e) => {
                                e.stopPropagation();
                                handleAddLabel(label.id);
                            }}
                        >
                            <span
                                style={{
                                    backgroundColor: label.color,
                                    color: 'white',
                                    padding: '2px 6px',
                                    borderRadius: '3px',
                                    fontSize: '11px'
                                }}
                            >
                                {label.name}
                            </span>
                        </Button>
                    ))}
                </div>
            </Popover.Body>
        </Popover>
    );

    return (
        <OverlayTrigger
            trigger="click"
            placement="bottom"
            overlay={popover}
            show={showPopover}
            onToggle={setShowPopover}
            rootClose
        >
            <Button
                variant="outline-secondary"
                size="sm"
                style={{ padding: '2px 6px', fontSize: '10px' }}
                onClick={(e) => {
                    e.stopPropagation();
                    setShowPopover(!showPopover);
                }}
            >
                <Plus size={10} />
            </Button>
        </OverlayTrigger>
    );
};

export default QuickLabelAdd;
